import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

export default function ConfirmationDialog(props) {
  const {
    title,
    description,
    primaryButtonText,
    secondaryButtonText,
    open,
    onClose,
    onSecondaryButtonClick,
    onPrimaryButtonClick,
  } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSecondaryButtonClick}>{secondaryButtonText}</Button>
        <Button variant="contained" onClick={onPrimaryButtonClick} color="secondary" autoFocus>
          {primaryButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialog.defaultProps = {
  title: '',
  description: '',
  primaryButtonText: '',
  secondaryButtonText: '',
  open: false,
  onClose: () => {},
  onSecondaryButtonClick: () => {},
  onPrimaryButtonClick: () => {},
};

ConfirmationDialog.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  primaryButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSecondaryButtonClick: PropTypes.func,
  onPrimaryButtonClick: PropTypes.func,
};
